/* KOYA — theme interactions (framework-free) */
(function () {
  'use strict';
  var CFG = window.KOYA || {};

  /* ---------- Money ---------- */
  function formatMoney(cents, fmt) {
    fmt = fmt || CFG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ''); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Sticky header ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function (el, i) { el.style.transitionDelay = ((i % 3) * 70) + 'ms'; io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- Cart drawer open/close ---------- */
  var overlay = document.querySelector('.drawer-overlay');
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() {
    if (!overlay || !drawer) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('open'); drawer.classList.add('open'); });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('open'); drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 350);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-cart]');
    if (opener) { e.preventDefault(); openDrawer(); }
    var closer = e.target.closest('[data-close-cart]');
    if (closer) {
      // Real links (e.g. "Shop the Brightening Bar" in the empty cart) must still navigate.
      if (!closer.getAttribute('href')) e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeNav(); } });

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  function closeNav() { if (mobileNav) { mobileNav.classList.remove('open'); document.body.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-nav]')) {
      e.preventDefault();
      if (mobileNav) { mobileNav.classList.toggle('open'); document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : ''; }
    }
  });

  /* ---------- Variant / bundle selector ---------- */
  document.querySelectorAll('[data-variant-selector]').forEach(function (root) {
    var form = root.closest('form') || document.querySelector('form[data-product-form], form.product-form');
    var idInput = root.querySelector('[name="id"]') || (form && form.querySelector('[name="id"]'));
    var opts = root.querySelectorAll('[data-variant-option]');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
        opt.classList.add('is-active'); opt.setAttribute('aria-checked', 'true');
        if (idInput && opt.dataset.variantId) idInput.value = opt.dataset.variantId;
        var priceEls = document.querySelectorAll('[data-selected-price]');
        priceEls.forEach(function (el) { if (opt.dataset.price != null) el.textContent = formatMoney(opt.dataset.price); });
        var atc = document.querySelector('[data-atc-label]');
        if (atc && opt.dataset.price != null) atc.textContent = 'Add to bag — ' + formatMoney(opt.dataset.price);

        var price = opt.dataset.price != null ? parseInt(opt.dataset.price, 10) : null;
        var compareAt = opt.dataset.compareAt ? parseInt(opt.dataset.compareAt, 10) : 0;
        var discounted = price != null && compareAt > price;
        var pct = discounted ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

        // Crossed-out price + save badge next to the price
        var wasEl = document.querySelector('[data-compare-price]');
        var saveEl = document.querySelector('[data-save-badge]');
        if (wasEl && saveEl && price != null) {
          if (discounted) {
            wasEl.textContent = formatMoney(compareAt);
            saveEl.textContent = 'Save ' + pct + '%';
            wasEl.hidden = false; saveEl.hidden = false;
          } else {
            wasEl.hidden = true; saveEl.hidden = true;
          }
        }

        // Corner "Save X%" flag on the buy-box image
        document.querySelectorAll('[data-save-flag]').forEach(function (flag) {
          if (discounted) { flag.textContent = 'Save ' + pct + '%'; flag.hidden = false; }
          else { flag.hidden = true; }
        });

        // Show this variant's own photo, when it has one
        var vImg = opt.dataset.variantImage;
        if (vImg) {
          var bb = document.querySelector('[data-buybox-image]');
          if (bb) bb.src = vImg;
          var gm = document.querySelector('[data-gallery-main]');
          if (gm) gm.src = vImg;
          document.querySelectorAll('[data-buybox-thumb], [data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.dataset.full === vImg);
          });
        }
      });
      opt.setAttribute('role', 'radio');
    });
  });

  /* ---------- Buy-box thumbnails ---------- */
  document.querySelectorAll('[data-buybox-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-buybox-image]');
      if (main && thumb.dataset.full) main.src = thumb.dataset.full;
      document.querySelectorAll('[data-buybox-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.full || thumb.querySelector('img').src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('form[data-product-form], form.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Never intercept Shopify's dynamic checkout / "Buy now" buttons — they must
      // submit natively so Shopify can take the customer straight to checkout.
      var submitter = e.submitter;
      if (submitter) {
        if (submitter.closest('.shopify-payment-button')) return;
        if (submitter.name && submitter.name !== 'add') return;
      }
      e.preventDefault();
      var btn = form.querySelector('[name="add"], [type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.innerHTML = 'Adding…'; }
      fetch(CFG.cartUrl.replace(/\/cart$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(serialize(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer(); })
        .catch(function () { window.location.href = CFG.cartUrl; })
        .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = original; } });
    });
  });

  function serialize(form) {
    var data = { items: [{ id: form.querySelector('[name="id"]').value, quantity: parseInt(form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1, 10) || 1 }] };
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && sp.value) data.items[0].selling_plan = sp.value;
    return data;
  }

  /* ---------- Cart change (qty / remove) ---------- */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]'), down = e.target.closest('[data-qty-down]'), rem = e.target.closest('[data-remove]');
    var el = up || down || rem;
    if (!el) return;
    e.preventDefault();
    var line = el.closest('.cart-line');
    var current = line ? parseInt(line.querySelector('[data-qty]').textContent, 10) : 1;
    var qty = rem ? 0 : (up ? current + 1 : Math.max(0, current - 1));
    changeCart(el.dataset.key, qty);
  });

  function changeCart(key, quantity) {
    return fetch(CFG.cartUrl.replace(/\/cart$/, '') + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  /* ---------- Refresh / render cart ---------- */
  function refreshCart() {
    return fetch(CFG.cartUrl.replace(/\/cart$/, '') + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function renderCart(cart) {
    // count
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
    });
    // subtotal
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    // footer
    var footer = document.querySelector('[data-cart-footer]');
    if (footer) footer.hidden = cart.item_count === 0;
    // items
    var container = document.querySelector('[data-cart-items]');
    if (container) container.innerHTML = cart.item_count ? cartItemsHTML(cart) : emptyHTML();
    // free shipping bar
    updateShipBar(cart.total_price);
  }

  function cartItemsHTML(cart) {
    var rows = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" width="72" height="72" loading="lazy">' : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
      var plan = item.selling_plan_allocation ? '<div class="cart-line__variant">' + item.selling_plan_allocation.selling_plan.name + '</div>' : '';
      return '<li class="cart-line" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-line__img">' + img + '</a>' +
        '<div class="cart-line__info"><div class="cart-line__title">' + item.product_title + '</div>' + variant + plan +
        '<div class="cart-line__qty">' +
        '<button type="button" class="qbtn" data-qty-down data-key="' + item.key + '" aria-label="Decrease">' + icon('minus') + '</button>' +
        '<span data-qty>' + item.quantity + '</span>' +
        '<button type="button" class="qbtn" data-qty-up data-key="' + item.key + '" aria-label="Increase">' + icon('plus') + '</button>' +
        '<button type="button" class="cart-line__remove" data-remove data-key="' + item.key + '">Remove</button>' +
        '</div></div>' +
        '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div></li>';
    }).join('');
    return '<ul class="cart-lines">' + rows + '</ul>';
  }
  function emptyHTML() {
    var url = CFG.emptyCtaUrl || '/collections/all';
    var label = CFG.emptyCtaLabel || 'Shop the Brightening Bar';
    return '<div class="cart-empty"><p style="font-family:var(--serif);font-size:1.3rem;margin-bottom:.4em">Your bag is empty</p>' +
      '<p style="color:var(--ink-2);margin-bottom:1.4em">Ready to start your glow-up?</p>' +
      '<a href="' + url + '" class="btn btn--primary" data-close-cart>' + label + '</a></div>';
  }
  function icon(name) { return '<svg aria-hidden="true"><use href="#' + name + '"></use></svg>'; }

  function updateShipBar(total) {
    var bar = document.querySelector('[data-ship-bar]');
    if (!bar || !CFG.freeShipEnabled || !CFG.freeShipThreshold) return;
    var msg = bar.querySelector('[data-ship-msg]'), fill = bar.querySelector('[data-ship-fill]');
    var pct = Math.min(100, (total / CFG.freeShipThreshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (total >= CFG.freeShipThreshold) { msg.innerHTML = '🎉 ' + CFG.strings.free; }
      else { msg.innerHTML = 'You\'re <strong>' + formatMoney(CFG.freeShipThreshold - total) + '</strong> ' + CFG.strings.away; }
    }
  }
  // init ship bar from server-rendered subtotal
  var initSub = document.querySelector('[data-cart-subtotal]');
  if (initSub) { /* server already rendered items; set bar from current cart */ refreshShipOnLoad(); }
  function refreshShipOnLoad() {
    if (!CFG.freeShipEnabled) return;
    fetch(CFG.cartUrl.replace(/\/cart$/, '') + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { updateShipBar(c.total_price); }).catch(function () {});
  }

  /* ---------- Lazy hero/CTA video ---------- */
  var vids = document.querySelectorAll('video[data-lazy]');
  if ('IntersectionObserver' in window && vids.length) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.dataset.src && !v.src) v.src = v.dataset.src; var p = v.play(); if (p) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- FAQ / details: close siblings (optional single-open) ---------- */
  document.querySelectorAll('.faq details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) { d.parentElement.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; }); }
    });
  });
})();
